import React from 'react';
import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';

import {withStyles} from '@material-ui/core/styles';
import {CustomButton} from '../../material-dashboard-pro-react/components/index';
import {Delete} from '../../icons/index';
import style from '../../styles/components/button';

function ButtonDeleteEntity(props) {
  const {
    classes,
    customClasses,
    disabled,
    entityType,
    onClick,
    text,
  } = props;

  const buttonText = text || I18n.t('buttons.deleteEntity', {entityType: entityType});
  return (
    <CustomButton
      color="redNoBackground"
      customClasses={customClasses}
      disabled={disabled}
      onClick={onClick}
      size="xs"
    >
      <Delete className={classes.button__icon} />
      {buttonText.toUpperCase()}
    </CustomButton>
  );
}

ButtonDeleteEntity.propTypes = {
  classes: PropTypes.object.isRequired,
  customClasses: PropTypes.string,
  disabled: PropTypes.bool,
  entityType: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string,
};

ButtonDeleteEntity.defaultProps = {
  customClasses: '',
  disabled: false,
  entityType: '',
  text: null,
};

export default withStyles(style)(ButtonDeleteEntity);
